import { CompetitionTeamWriteRequest, PatchedCompetitionTeamWriteRequest } from '~/apis/ssf';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateCompetitionTeamMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (payload: CompetitionTeamWriteRequest) => SSF.api.competitionTeamsCreate(payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function usePartialUpdateCompetitionTeamMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: PatchedCompetitionTeamWriteRequest }) =>
      SSF.api.competitionTeamsPartialUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteCompetitionTeamMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.competitionTeamsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
